import { render } from "./GestaoDeProjetos.vue?vue&type=template&id=0c040b4a"
import script from "./GestaoDeProjetos.vue?vue&type=script&lang=js"
export * from "./GestaoDeProjetos.vue?vue&type=script&lang=js"

import "./GestaoDeProjetos.vue?vue&type=style&index=0&id=0c040b4a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__